import { RentStage } from '@tallo/property';

import { byStages, InquiryFilter } from './inquiry-filter.const';

export enum PropertyLeadsFilter {
  ALL = 'All',
  PENDING = 'Pending',
  ACCEPTED = 'Accepted',
  RESCHEDULING = 'Rescheduling',
  SHOWING_COMPLETED = 'Showing Completed',
  NOT_QUALIFIED = 'Not Qualified',
  CANCELED = 'Canceled',
  DECLINED = 'Declined',
  EXPIRED = 'Expired',
  NO_LONGER_INTERESTED = 'No Longer Interested',
}

export const leadsFilterPredicates = new Map<PropertyLeadsFilter, InquiryFilter>([
  [PropertyLeadsFilter.PENDING, byStages(RentStage.SHOWING_REQUESTED)],
  [PropertyLeadsFilter.ACCEPTED, byStages(RentStage.SHOWING_CONFIRMED)],
  [PropertyLeadsFilter.DECLINED, byStages(RentStage.SHOWING_DECLINED)],
  [
    PropertyLeadsFilter.RESCHEDULING,
    byStages(RentStage.SHOWING_RESCHEDULE_REQUESTED_BY_OWNER, RentStage.SHOWING_RESCHEDULE_REQUESTED_BY_RENTER),
  ],
  [PropertyLeadsFilter.SHOWING_COMPLETED, byStages(RentStage.SHOWING_COMPLETED, RentStage.APPLICATION_INVITE_SENT)],
  [
    PropertyLeadsFilter.CANCELED,
    byStages(
      RentStage.SHOWING_CANCELLED_BY_OWNER,
      RentStage.SHOWING_CANCELLED_BY_RENTER,
      RentStage.IDENTITY_VERIFICATION_FAILED,
      RentStage.STOPPED_PROPERTY_RENTED_OUT,
    ),
  ],
  [PropertyLeadsFilter.EXPIRED, byStages(RentStage.SHOWING_REQUEST_IGNORED_BY_OWNER)],
  [PropertyLeadsFilter.NOT_QUALIFIED, byStages(RentStage.REQUIREMENTS_NOT_MET)],
  [PropertyLeadsFilter.NO_LONGER_INTERESTED, byStages(RentStage.NO_LONGER_INTERESTED, RentStage.WENT_SILENT)],
]);
